import React, { useState } from 'react';
import { useStorePickerContext } from './store-picker-context';
import StorePicker from './store-picker';
import StoreInformation from './store-information';

function StockInfoSection() {
  const { zipCodeValid, isLoading } = useStorePickerContext();
  const [storeLocatorOpen, setStoreLocatorOpen] = useState(false);

  const handleOnClose = () => {
    setStoreLocatorOpen((prev) => !prev);
  };

  return (
    <>
      {zipCodeValid && !isLoading && (
        <StoreInformation handleStorePicker={handleOnClose} />
      )}
      {storeLocatorOpen && (
        <StorePicker isOpen={storeLocatorOpen} onClose={handleOnClose} />
      )}
    </>
  );
}

export default StockInfoSection;
